// extracted by mini-css-extract-plugin
export default {"dateYellowBox":"styles_dateYellowBox__I6ZRK","datePickerRoot":"styles_datePickerRoot__Klzsp"};